<!--<div class="btn-group  btn-group-toggle" [ngClass]="{'btn-group-sm': size=='sm'}" ngbRadioGroup [(ngModel)]="status" (ngModelChange)="changed($event)">-->
<!--   <label *ngFor="let s of statusList" ngbButtonLabel class="btn-success">-->
<!--      <input ngbButton type="radio" name="status" [value]="s.toLowerCase()">{{s}}</label>-->
<!--</div>-->
<p-selectButton [options]="listOfItems" [(ngModel)]="status" (ngModelChange)="changed($event)"></p-selectButton>
